// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `::ng-deep .mat-mdc-dialog-container {
    height: initial;
    overflow: initial;
}





::ng-deep .mat-dialog-container {
    display: block;
    padding: 24px;
    border-radius: 4px;
    box-sizing: border-box;
    overflow: auto;
    outline: 0;
    width: 100%;
    height: 100%;
    min-height: inherit;
    max-height: inherit
}

@media (-ms-high-contrast:active) {
    .mat-dialog-container {
        outline: solid 1px
    }
}

::ng-deep .mat-dialog-content {
    display: block;
    margin: 0 -24px;
    padding: 0 24px;
    max-height: 65vh;
    overflow: auto;
    -webkit-overflow-scrolling: touch
}

::ng-deep .mat-dialog-title {
    margin: 0 0 20px;
    display: block
}

::ng-deep .mat-dialog-actions {
    padding: 8px 0;
    display: flex;
    flex-wrap: wrap;
    min-height: 52px;
    align-items: center;
    margin-bottom: -24px
}

::ng-deep .mat-dialog-actions[align=end] {
    justify-content: flex-end
}

::ng-deep .mat-dialog-actions[align=center] {
    justify-content: center
}

::ng-deep .mat-dialog-actions .mat-button-base+.mat-button-base {
    margin-left: 8px
}

::ng-deep [dir=rtl] .mat-dialog-actions .mat-button-base+.mat-button-base {
    margin-left: 0;
    margin-right: 8px
}




::ng-deep .mat-mdc-dialog-container .mdc-dialog__surface {
    display: block !important;
    /* padding: 24px !important; */
    border-radius: 4px !important;
    box-sizing: border-box !important;
    overflow: auto !important;
    outline: 0 !important;
    width: 100% !important;
    height: 100% !important;
    min-height: inherit !important;
    max-height: inherit !important;
}



.custom-dialog .mat-mdc-dialog-container {
    display: block !important;
    /* padding: 24px !important; */
    border-radius: 4px !important;
    overflow: auto !important;
    height: 100% !important;
}



::ng-deep .mat-mdc-dialog-container .mdc-dialog__surface {
    display: block !important;
    /* padding: 24px !important; */
    border-radius: 4px !important;
    box-sizing: border-box !important;
    overflow: auto !important;
    outline: 0 !important;
    width: 100% !important;
    height: 100% !important;
    min-height: inherit !important;
    max-height: inherit !important;
}



.custom-dialog .mat-mdc-dialog-container {
    display: block !important;
    padding: 24px !important;
    border-radius: 4px !important;
    overflow: auto !important;
    height: 100% !important;
}


`, "",{"version":3,"sources":["webpack://./src/app/views/media-manager/add-folder-dialog/add-folder-dialog.component.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,iBAAiB;AACrB;;;;;;AAMA;IACI,cAAc;IACd,aAAa;IACb,kBAAkB;IAClB,sBAAsB;IACtB,cAAc;IACd,UAAU;IACV,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,cAAc;IACd,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI,cAAc;IACd,aAAa;IACb,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;;;;AAKA;IACI,yBAAyB;IACzB,8BAA8B;IAC9B,6BAA6B;IAC7B,iCAAiC;IACjC,yBAAyB;IACzB,qBAAqB;IACrB,sBAAsB;IACtB,uBAAuB;IACvB,8BAA8B;IAC9B,8BAA8B;AAClC;;;;AAIA;IACI,yBAAyB;IACzB,8BAA8B;IAC9B,6BAA6B;IAC7B,yBAAyB;IACzB,uBAAuB;AAC3B;;;;AAIA;IACI,yBAAyB;IACzB,8BAA8B;IAC9B,6BAA6B;IAC7B,iCAAiC;IACjC,yBAAyB;IACzB,qBAAqB;IACrB,sBAAsB;IACtB,uBAAuB;IACvB,8BAA8B;IAC9B,8BAA8B;AAClC;;;;AAIA;IACI,yBAAyB;IACzB,wBAAwB;IACxB,6BAA6B;IAC7B,yBAAyB;IACzB,uBAAuB;AAC3B","sourcesContent":["::ng-deep .mat-mdc-dialog-container {\r\n    height: initial;\r\n    overflow: initial;\r\n}\r\n\r\n\r\n\r\n\r\n\r\n::ng-deep .mat-dialog-container {\r\n    display: block;\r\n    padding: 24px;\r\n    border-radius: 4px;\r\n    box-sizing: border-box;\r\n    overflow: auto;\r\n    outline: 0;\r\n    width: 100%;\r\n    height: 100%;\r\n    min-height: inherit;\r\n    max-height: inherit\r\n}\r\n\r\n@media (-ms-high-contrast:active) {\r\n    .mat-dialog-container {\r\n        outline: solid 1px\r\n    }\r\n}\r\n\r\n::ng-deep .mat-dialog-content {\r\n    display: block;\r\n    margin: 0 -24px;\r\n    padding: 0 24px;\r\n    max-height: 65vh;\r\n    overflow: auto;\r\n    -webkit-overflow-scrolling: touch\r\n}\r\n\r\n::ng-deep .mat-dialog-title {\r\n    margin: 0 0 20px;\r\n    display: block\r\n}\r\n\r\n::ng-deep .mat-dialog-actions {\r\n    padding: 8px 0;\r\n    display: flex;\r\n    flex-wrap: wrap;\r\n    min-height: 52px;\r\n    align-items: center;\r\n    margin-bottom: -24px\r\n}\r\n\r\n::ng-deep .mat-dialog-actions[align=end] {\r\n    justify-content: flex-end\r\n}\r\n\r\n::ng-deep .mat-dialog-actions[align=center] {\r\n    justify-content: center\r\n}\r\n\r\n::ng-deep .mat-dialog-actions .mat-button-base+.mat-button-base {\r\n    margin-left: 8px\r\n}\r\n\r\n::ng-deep [dir=rtl] .mat-dialog-actions .mat-button-base+.mat-button-base {\r\n    margin-left: 0;\r\n    margin-right: 8px\r\n}\r\n\r\n\r\n\r\n\r\n::ng-deep .mat-mdc-dialog-container .mdc-dialog__surface {\r\n    display: block !important;\r\n    /* padding: 24px !important; */\r\n    border-radius: 4px !important;\r\n    box-sizing: border-box !important;\r\n    overflow: auto !important;\r\n    outline: 0 !important;\r\n    width: 100% !important;\r\n    height: 100% !important;\r\n    min-height: inherit !important;\r\n    max-height: inherit !important;\r\n}\r\n\r\n\r\n\r\n.custom-dialog .mat-mdc-dialog-container {\r\n    display: block !important;\r\n    /* padding: 24px !important; */\r\n    border-radius: 4px !important;\r\n    overflow: auto !important;\r\n    height: 100% !important;\r\n}\r\n\r\n\r\n\r\n::ng-deep .mat-mdc-dialog-container .mdc-dialog__surface {\r\n    display: block !important;\r\n    /* padding: 24px !important; */\r\n    border-radius: 4px !important;\r\n    box-sizing: border-box !important;\r\n    overflow: auto !important;\r\n    outline: 0 !important;\r\n    width: 100% !important;\r\n    height: 100% !important;\r\n    min-height: inherit !important;\r\n    max-height: inherit !important;\r\n}\r\n\r\n\r\n\r\n.custom-dialog .mat-mdc-dialog-container {\r\n    display: block !important;\r\n    padding: 24px !important;\r\n    border-radius: 4px !important;\r\n    overflow: auto !important;\r\n    height: 100% !important;\r\n}\r\n\r\n\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
